import { render, staticRenderFns } from "./home-mcp-announcement.component.vue?vue&type=template&id=b5494a9e&scoped=true&"
import script from "./home-mcp-announcement.component.vue?vue&type=script&lang=ts&"
export * from "./home-mcp-announcement.component.vue?vue&type=script&lang=ts&"
import style0 from "./home-mcp-announcement.component.vue?vue&type=style&index=0&id=b5494a9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5494a9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
